var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -8.91429,
    y: -8.91429,
    width: 33.8286,
    height: 33.8286
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(4.46px)",
      clipPath: "url(#bgblur_0_12254_543_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-figma-bg-blur-radius": 8.91429,
    cx: 8,
    cy: 8,
    r: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.993 5.71634C11.9943 5.86617 11.9367 6.01051 11.8326 6.11829L7.54686 10.404C7.4397 10.5111 7.29438 10.5713 7.14286 10.5713C6.99133 10.5713 6.84602 10.5111 6.73886 10.404L4.45314 8.11829C4.34905 8.01051 4.29146 7.86617 4.29276 7.71634C4.29406 7.56652 4.35416 7.42319 4.4601 7.31725C4.56605 7.2113 4.70937 7.1512 4.8592 7.1499C5.00903 7.1486 5.15337 7.2062 5.26114 7.31029L7.14286 9.192L11.0246 5.31029C11.1323 5.2062 11.2767 5.1486 11.4265 5.1499C11.5763 5.1512 11.7197 5.2113 11.8256 5.31725C11.9316 5.42319 11.9917 5.56652 11.993 5.71634Z",
    fill: "#2045FE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_12254_543_clip_path",
    transform: "translate(8.91429 8.91429)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYes);
export default __webpack_public_path__ + "static/media/yes.4d466bcbbef0da80c407f1b666b552b1.svg";
export { ForwardRef as ReactComponent };